import { render } from "./GhanaChapterContent.vue?vue&type=template&id=96aebf88&scoped=true&ts=true"
import script from "./GhanaChapterContent.vue?vue&type=script&lang=ts"
export * from "./GhanaChapterContent.vue?vue&type=script&lang=ts"

import "./GhanaChapterContent.vue?vue&type=style&index=0&id=96aebf88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96aebf88"]])

export default __exports__